import { useState, useEffect, useRef } from "react";
import Suggestions from "../../pages/referendums/Suggestions";
import { motion } from "framer-motion";
import MetadataSetup from "../MetadataSetup.js";
import Log from "../analytics/Log.jsx";

import { dateNowByServer, getVotingDurationByOrigServer } from "../../helpers/date.js";
// import { useNavigate } from "react-router-dom";
import topReferendumCacheHelper from "../../helpers/topReferendumCacheHelper";
import hotRefsCacheHelper from "../../helpers/hotRefsCacheHelper";
import trendingRefsCacheHelper from "../../helpers/trendingRefsCacheHelper";
import helpThemOutRefsCacheHelper from "../../helpers/helpThemOutRefsCacheHelper";
import axiosWithCacheConfig from "../../helpers/axiosWithCacheConfig.js";
import auth from "../../helpers/auth";
import searchIcon from "../../assets/images/home/search.svg";
import Footer from "../layouts/footer.js";
import { hasMainContentScroll } from "../../helpers/jsHelper";
import serverTimeHelper from "../../helpers/serverTimeHelper.js";

function Main() {
  // const navigate = useNavigate();
  const search_key_ref = useRef();

  const [topRefs, setTopRefs] = useState([]);
  const [hotRefs, setHotRefs] = useState([]);
  const [trendingRefs, setTrendingRefs] = useState([]);
  const [helpThemOutRefs, setHelpThemOutRefs] = useState([]);

  const [topStatus, setTopStatus] = useState("updating");
  const [hotStatus, setHotStatus] = useState("updating");
  const [trendingStatus, setTrendingStatus] = useState("updating");
  const [helpStatus, setHelpStatus] = useState("updating");

  window.addEventListener("resize", () => {
    hasMainContentScroll("main-home");
  })

  useEffect(
    () => {
      fetchHomeSuggestions();
      hasMainContentScroll("main-home");
    },
    // eslint-disable-next-line
    []
  );

  function getCache(group, statusSetter, valueSetter) {

    let helpers = {
      top: topReferendumCacheHelper,
      hot: hotRefsCacheHelper,
      trending: trendingRefsCacheHelper,
      help: helpThemOutRefsCacheHelper,
    }

    let cache = helpers[group].get();
    if (cache.length) {
      statusSetter("updated");
      setupSuggestions(cache, valueSetter);
    }
  }

  async function fetchHomeSuggestions() {

    // getCache("top", setTopStatus, setTopRefs);
    // getCache("hot", setHotStatus, setHotRefs);
    // getCache("trending", setTrendingStatus, setTrendingRefs);
    // getCache("help", setHelpStatus, setHelpThemOutRefs);

    let url = process.env.REACT_APP_ENVIRONMENT === "development" ? `http://${process.env.REACT_APP_HOST}:3004/op/v1/referendums/suggestions?group=home` : "https://api.onepeople.online/op/v1/referendums/suggestions?group=home";
    axiosWithCacheConfig
      .get(
        url,
        {
          headers: {
            Authorization: `Bearer ${auth.getToken()}`,
          },
        }
      )
      .then((res) => {
        if (res.data.success) {
          setupSuggestions(res.data.referendums.top, setTopRefs);
          topReferendumCacheHelper.set(res.data.referendums.top);

          setupSuggestions(res.data.referendums.hot, setHotRefs);
          hotRefsCacheHelper.set(res.data.referendums.hot);

          setupSuggestions(res.data.referendums.trending, setTrendingRefs);
          trendingRefsCacheHelper.set(res.data.referendums.trending);

          setupSuggestions(res.data.referendums.help, setHelpThemOutRefs);
          helpThemOutRefsCacheHelper.set(res.data.referendums.help);
        }
      })
      .catch((errs) => {
        auth.checkErrors(errs);
      })
      .finally(() => {
        setTopStatus("updated");
        setHotStatus("updated");
        setTrendingStatus("updated");
        setHelpStatus("updated");
        hasMainContentScroll("main-home")
      });
  }

  const setupSuggestions = (refs, setRef) => {
    refs = refs.slice(0, 8).map((ref, index) => {

      let dateNow = dateNowByServer(serverTimeHelper.get(), serverTimeHelper.clientTime())
      let tempStatus = getVotingDurationByOrigServer(ref.end_at, dateNow);
      ref = { ...ref, ...tempStatus };
      return ref;
    });

    setRef(refs);
  };

  function onSearch(e) {
    e.preventDefault();
    if (search_key_ref.current.value !== "") {
      window.location.href = `/search?q=${search_key_ref.current.value}`;
    } else {
      // navigate(`/search`);
      window.location.href = `/search/`;
    }
  }

  return (
    <Log logImpression event="page-view" page="Home">
      <MetadataSetup
        title="OnePeople: Vote, and share."
        canonical="https://onepeople.online/"
        description="Tap into the wisdom of the crowds, and learn something new today!"
      />
      <div className="main main-home">
        <div className="top home">
          <h1 className="home-header-txt d-none d-md-block">
            What would you like to know?
          </h1>
          <form onSubmit={onSearch} className="search-form">
            <div>
              <img
                src={searchIcon}
                alt="search icon"
                className="icon"
              />
              <input
                className="hl-border-xs"
                ref={search_key_ref}
                type="text"
                name="key"
                placeholder="Search referendums for topics or keywords"
              />
            </div>
          </form>
        </div>
        <div className="center row mt-0 mt-md-0 mt-lg-4 pt-4 pb-3">
          <motion.div
            className="col-12 col-md-12 col-lg-6 col-xl-6 col-xxl-3 mb-4 "
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.3 }}
          >
            <Suggestions
              url="/top/"
              updateStatus={topStatus}
              small={false}
              referendums={topRefs}
              title="Top Referendums"
              errorMsg={`No Top Referendums Found`}
              unicode="&#x1F3C6;"
              limit={8}
            />
          </motion.div>
          <motion.div
            className="col-12 col-md-12 col-lg-6 col-xl-6 col-xxl-3 mb-4"
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.3 }}
          >
            <Suggestions
              url="/hotly-contested/"
              updateStatus={hotStatus}
              small={false}
              referendums={hotRefs}
              title="Hotly Contested"
              errorMsg={`No Hotly Contested Found`}
              unicode="&#128293;"
              limit={8}
            />
          </motion.div>

          <motion.div
            className="col-12 col-md-12 col-lg-6 col-xl-6 col-xxl-3 mb-4 mb-md-4 mb-lg-0 mb-xxl-4"
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.3 }}
          >
            <Suggestions
              url="/trending/"
              updateStatus={trendingStatus}
              small={false}
              referendums={trendingRefs}
              title="Trending"
              unicode="&#128200;"
              errorMsg={`No Trending Found`}
              limit={8}
            />
          </motion.div>

          <motion.div
            className="col-12 col-md-12 col-lg-6 col-xl-6 col-xxl-3 mb-0 mb-xxl-4"
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.3 }}
          >
            <Suggestions
              url="/help-them-out/"
              updateStatus={helpStatus}
              small={false}
              referendums={helpThemOutRefs}
              title="Help Them Out"
              errorMsg={`No Help Them Out Found`}
              unicode="&#128075;"
              limit={8}
            />
          </motion.div>
        </div>
      </div>
      <Footer customClass={"inside-footer"} />
    </Log>
  );
}

export default Main;
